import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ColorsService {
  //
  // Color Palette
  //
  typeOf: string;
  shadeBase: string;
  shadeOne: string;
  shadeTwo: string;
  shadeThree: string;
  shadeFour: string;
  neutral: string;
  offsetOne: string;
  offsetTwo: string;
  offsetThree: string;
  offsetFour: string;
  accentOne: string;
  accentTwo: string;
  accentThree: string;
  accentFour: string;
  textIcons: string;
  light: string;
  lightPrimaryColor: string;
  dividerColor: string;
  primary: string;
  secondaryText: string;
  darkPrimaryColor: string;
  dark: string;
  primaryText: string;
  warning: string;
  accentColor: string;
  secondary: string;
  info: string;
  //
  // Branding Variables
  //
  headerBackground: string;
  headerColor: string;
  footerBackground: string;
  footerColor: string;
  boxShadows: string;
  dropShadows: string;
  link: string;
  hoverFocus: string;
  bodyColor: string;
  bodyBackground: string;
  buttonColor: string;
  buttonBackground: string;
  buttonBorder: string;
  fontFamilySansSerif: string;
  fontFamilyMonospace: string;
  h1Size: string;
  h1Color: string;
  h2Size: string;
  h2Color: string;
  h3Size: string;
  h3Color: string;
  //
  // Color declarations for Yahoo buttons...
  //
  colorRed: string;
  colorPink: string;
  colorPurple: string;
  colorDeepPurple: string;
  colorIndigo: string;
  colorBlue: string;
  colorLightBlue: string;
  colorCyan: string;
  colorTeal: string;
  colorGreen: string;
  colorLightGreen: string;
  colorLime: string;
  colorYellow: string;
  colorAmber: string;
  colorOrange: string;
  colorDeepOrange: string;
  colorBrown: string;
  colorGrey: string;
  colorBlueGrey: string;
  // not Angular Color Palette.
  colorLight: string;
  colorDark: string;
  colorPurpleRain: string;
  colorMidnightBlue: string;
  colorRoyal: string;
  colorBabyBlue: string;
  sephia: string;
  starterTheme: string;
  themeName: string;

  colorDefaultsBS = new BehaviorSubject<any>(null);
  colorPalleteBS = new BehaviorSubject<any>(null);

  constructor() {}

  setColorPalleteBS(value) {
    this.colorPalleteBS.next(value);
  }
  getColorPalleteBS() {
    return this.colorPalleteBS.asObservable();
  }

  setColorDefaultsBS(value) {
    this.colorDefaultsBS.next(value);
  }
  getColorDefaultsBS() {
    return this.colorDefaultsBS.asObservable();
  }

  // default colors are themes.scss :root values
  defaultColorTheme() {
    const obj = {
      themeName: '',
      starterTheme: 'default',
      typeOf: 'default',
      shadeBase: '#333',
      shadeOne: '#212121',
      shadeTwo: '#424242',
      shadeThree: '#616161',
      // shadeFour :'#B4A49C',
      shadeFour: '#757575',
      neutral: '#9e9e9e',
      offsetOne: '#bdbdbd',
      offsetTwo: '#e0e0e0',
      offsetThree: '#eeeeee',
      offsetFour: '#fafafa',
      accentOne: '#8c9eff',
      accentTwo: '#536dfe',
      accentThree: '#3d5afe',
      accentFour: '#304ffe',
      // set Local Variables
      headerBackground: '#fafafa',
      headerColor: '#212121',
      footerBackground: '#fafafa',
      footerColor: '#212121',
      bodyColor: '#212121',
      bodyBackground: '#fafafa',
      boxShadows: '#777777',
      dropShadows: '#777777',
      link: '#303650',
      hoverFocus: '#111d50',
      buttonColor: '#fafafa',
      buttonBackground: '#111d50',
      buttonBorder: '#111d50',
      fontFamilySansSerif:
        '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      fontFamilyMonospace:
        '"SFMono-Regular",Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setBlueGrey() {
    const obj = {
      themName: 'bluegrey0011-0022',
      starterTheme: 'bluegrey',
      typeOf: 'mat-blue-grey',
      shadeBase: '#eceff1',
      shadeOne: '#cfd8dc',
      shadeTwo: '#b0bec5',
      shadeThree: '#90a4ae',
      // shadeFour :'#8498A4',
      shadeFour: '#000000',
      neutral: '#7D9AA5',
      offsetOne: '#7C9CA6',
      offsetTwo: '#92A3A5',
      offsetThree: '#AEC4C6',
      offsetFour: '#A3B8C2',
      accentOne: '#eeeeee',
      accentTwo: '#9e9e9e',
      accentThree: '#4F4F4F',
      accentFour: '#A3A3A3',
      // set Local Variables
      headerBackground: '#CDDADA',
      headerColor: '#000000',
      footerBackground: '#CDDADA',
      footerColor: '#000000',
      bodyColor: '#000000',
      bodyBackground: '#eceff1',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#5B96F0',
      hoverFocus: '#5B96F0',
      buttonColor: '#fafafa',
      buttonBackground: '#669EFF',
      buttonBorder: '#669EFF',
      fontFamilySansSerif: '',
      fontFamilyMonospace: '',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setBrown() {
    const obj = {
      themeName: 'brown0011-0022',
      starterTheme: 'brown',
      typeOf: 'mat-brown',
      shadeBase: '#efebe9',
      shadeOne: '#d7ccc8',
      shadeTwo: '#bcaaa4',
      shadeThree: '#AA958D',
      // shadeFour :'#B4A49C',
      shadeFour: '#000000',
      neutral: '#B58F82',
      offsetOne: '#BB998B',
      offsetTwo: '#AA9A92',
      offsetThree: '#C3B9B6',
      offsetFour: '#BC908A',
      accentOne: '#eeeeee',
      accentTwo: '#9e9e9e',
      accentThree: '#4A4A4A',
      accentFour: '#9C9C9C',
      // set Local Variables
      headerBackground: '#B48C83',
      headerColor: '#000000',
      footerBackground: '#B48C83',
      footerColor: '#000000',
      bodyColor: '#000000',
      bodyBackground: '#f1eded',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#BA8C87',
      hoverFocus: '#BA8C87',
      buttonColor: '#fafafa',
      buttonBackground: '#ACA09A',
      buttonBorder: '#ACA09A',

      fontFamilySansSerif: '',
      fontFamilyMonospace: '',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setRed() {
    const obj = {
      themeName: 'red0011-0022',
      starterTheme: 'red',
      typeOf: 'mat-red',
      shadeBase: '#ffebee',
      shadeOne: '#ffcdd2',
      shadeTwo: '#ef9a9a',
      shadeThree: '#e57373',
      // shadeFour :'#F16D6A',
      shadeFour: '#000000',
      neutral: '#B88E95',
      offsetOne: '#C58C93',
      offsetTwo: '#C99CA2',
      offsetThree: '#C6858B',
      offsetFour: '#E8B0BD',
      accentOne: '#ff8a80',
      accentTwo: '#FF6161',
      accentThree: '#AD0005',
      accentFour: '#FF6161',
      // set Local Variables
      headerBackground: '#FF6B6B',
      headerColor: '#000000',
      footerBackground: '#FF6B6B',
      footerColor: '#000000',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#FF5C79',
      hoverFocus: '#FF5C79',
      bodyColor: '#000000',
      bodyBackground: '#FFFFFF',
      buttonColor: '#fafafa',
      buttonBackground: '#FF99AE',
      buttonBorder: '#FF99AE',
      fontFamilySansSerif: '',
      fontFamilyMonospace: '',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setPink() {
    const obj = {
      themeName: 'pink0011-0022',
      starterTheme: 'pink',
      typeOf: 'mat-pink',
      shadeBase: '#fce4ec',
      shadeOne: '#f8bbd0',
      shadeTwo: '#f48fb1',
      shadeThree: '#F16A98',
      // shadeFour :'#F06B98',
      shadeFour: '#000000',
      neutral: '#F16F9D',
      offsetOne: '#EE6898',
      offsetTwo: '#fa87b0',
      offsetThree: '#ff95c3',
      offsetFour: '#EF62B0',
      accentOne: '#ff80ab',
      accentTwo: '#FF9EC0',
      accentThree: '#9E0024',
      accentFour: '#F363A2',
      // set Local Variables
      headerBackground: '#ffbdd3',
      headerColor: '#000000',
      footerBackground: '#ffbdd3',
      footerColor: '#000000',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#F165B5',
      hoverFocus: '#FF5791',
      bodyColor: '#000000',
      bodyBackground: '#fce4ec',
      buttonColor: '#fafafa',
      buttonBackground: '#F58FB5',
      buttonBorder: '#F58FB5',
      fontFamilySansSerif: '',
      fontFamilyMonospace: '',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setOrange() {
    const obj = {
      themeName: 'orange0011-0022',
      starterTheme: 'orange',
      typeOf: 'mat-orange',
      shadeBase: '#fff7f3',
      shadeOne: '#ffe0b2',
      shadeTwo: '#ffcc80',
      shadeThree: '#ffb74d',
      // shadeFour :'#ffa726',
      shadeFour: '#000000',
      neutral: '#ff9800',
      offsetOne: '#fb8c00',
      offsetTwo: '#ffa242',
      offsetThree: '#ffb77c',
      offsetFour: '#e65100',
      accentOne: '#ffd180',
      accentTwo: '#ffab40',
      accentThree: '#804700',
      accentFour: '#ff6d00',
      // set Local Variables
      headerBackground: '#ffe0b2',
      headerColor: '#000000',
      footerBackground: '#ffe0b2',
      footerColor: '#000000',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#e65100',
      hoverFocus: '#ef6c00',
      bodyColor: '#000000',
      bodyBackground: '#FEF9F6',
      buttonColor: '#ffb74d',
      buttonBackground: '#ff9800',
      buttonBorder: '#ff9800',

      fontFamilySansSerif: ' ',
      fontFamilyMonospace: ' ',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setPurple() {
    const obj = {
      themeName: 'purple0011-0022',
      starterTheme: 'purple',
      typeOf: 'mat-purple',
      shadeBase: '#f3e5f5',
      shadeOne: '#e1bee7',
      shadeTwo: '#ce93d8',
      shadeThree: '#C681D0',
      // shadeFour :'#ab47bc',
      shadeFour: '#000000',
      neutral: '#E0AAEE',
      offsetOne: '#D16FE2',
      offsetTwo: '#D16FE2',
      offsetThree: '#D16FE2',
      offsetFour: '#D16FE2',
      accentOne: '#ea80fc',
      accentTwo: '#F093FB',
      accentThree: '#8C009E',
      accentFour: '#D761FF',
      // set Local Variables
      headerBackground: '#ead3ee',
      headerColor: '#000000',
      footerBackground: '#ead3ee',
      footerColor: '#000000',
      bodyColor: '#000000',
      bodyBackground: '#fef7ff',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#B185EF',
      hoverFocus: '#C475E6',
      buttonColor: '#fafafa',
      buttonBackground: '#CF75E1',
      buttonBorder: '#CF71E0',
      fontFamilySansSerif: '#dcedc8',
      fontFamilyMonospace: '#dcedc8',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setLightBlue() {
    const obj = {
      themeName: 'lightblue0011-0022',
      starterTheme: 'lightblue',
      typeOf: 'mat-light-blue',
      shadeBase: '#e1f5fe',
      shadeOne: '#b3e5fc',
      shadeTwo: '#81d4fa',
      shadeThree: '#4fc3f7',
      // shadeFour :'#29b6f6',
      shadeFour: '#000000',
      neutral: '#03a9f4',
      offsetOne: '#03A3F2',
      offsetTwo: '#76b4d6',
      offsetThree: '#8bccf2',
      offsetFour: '#1599FE',
      accentOne: '#80d8ff',
      accentTwo: '#40c4ff',
      accentThree: '#005685',
      accentFour: '#009EFF',
      // set Local Variables
      headerBackground: '#cde2ec',
      headerColor: '#000000',
      footerBackground: '#cde2ec',
      footerColor: '#000000',
      bodyColor: '#000000',
      bodyBackground: '#fbfeff',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#149BFF',
      hoverFocus: '#1599FE',
      buttonColor: '#fafafa',
      buttonBackground: '#2FA3FE',
      buttonBorder: '#2FA3FE',
      fontFamilySansSerif: '',
      fontFamilyMonospace: '',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setRoyal() {
    const obj = {
      themeName: 'royal0011-0022',
      starterTheme: 'royal',
      typeOf: 'mat-blue',
      shadeBase: '#888FE7',
      shadeOne: '#cfd8dc',
      shadeTwo: '#b0bec5',
      shadeThree: '#90a4ae',
      // shadeFour :'#8498A4',
      shadeFour: '#000000',
      neutral: '#7D9AA5',
      offsetOne: '#888FE7',
      offsetTwo: '#659DC8',
      offsetThree: '#b0bec5',
      offsetFour: '#999FEB',
      accentOne: '#82b1ff',
      accentTwo: '#5C98FF',
      accentThree: '#619AFF',
      accentFour: '#BDCFFF',
      // set Local Variables
      headerBackground: '#8B8EE9',
      headerColor: '#000000',
      footerBackground: '#8B8EE9',
      footerColor: '#000000',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#0a19a5',
      hoverFocus: '#0019ff',
      bodyColor: '#000000',
      bodyBackground: '#e8f0f3',
      buttonColor: '#fafafa',
      buttonBackground: '#7A8EFA',
      buttonBorder: '#7A8EFA',
      fontFamilySansSerif: '',
      fontFamilyMonospace: '',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }

  setLightGreen() {
    const obj = {
      themeName: 'lightgreen0011-0022',
      starterTheme: 'lightgreen',
      typeOf: 'mat-light-green',
      shadeBase: '#33691e',
      shadeOne: '#dcedc8',
      shadeTwo: '#c5e1a5',
      shadeThree: '#aed581',
      // shadeFour :'#9ccc65', // 9ccc65
      shadeFour: '#000000',
      neutral: '#8bc34a',
      offsetOne: '#33691e', // 7cb342
      offsetTwo: '#c5e1a5', // 689f38
      offsetThree: '#dcedc8', // 558b2f
      offsetFour: '#33691e',
      accentOne: '#ccff90',
      accentTwo: '#b2ff59',
      accentThree: '#285C00',
      accentFour: '#64dd17',
      // set Local Variables
      headerBackground: '#dcedc8',
      headerColor: '#000000',
      footerBackground: '#dcedc8',
      footerColor: '#000000',
      bodyColor: '#000000',
      bodyBackground: '#f1f8e9',
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#33691e',
      hoverFocus: '#558b2f',
      buttonColor: '#f1f8e9',
      buttonBackground: '#33691e',
      buttonBorder: '#33691e',
      fontFamilySansSerif: '#dcedc8',
      fontFamilyMonospace: '#dcedc8',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };

    return obj;
  }

  setGreen() {
    const obj = {
      themeName: 'olivegreen0011-0022',
      starterTheme: 'olivegreen',
      typeOf: 'mat-green',
      shadeBase: '#2EAD36',
      shadeOne: '#c8e6c9',
      shadeTwo: '#a5d6a7',
      shadeThree: '#81c784',
      // shadeFour :'#245C2F',
      shadeFour: '#000000',
      neutral: '#4caf50',
      offsetOne: '#52B757',
      offsetTwo: '#4CCC6A',
      // offsetTwo ='#245C2F';
      offsetThree: '#3FB146',
      offsetFour: '#34C63C',
      accentOne: '#b9f6ca',
      accentTwo: '#69f0ae',
      accentThree: '#005726',
      accentFour: '#00c853',
      //set local Variables
      headerBackground: '#32AE4E',
      headerColor: '#000000',
      footerBackground: '#32AE4E',
      footerColor: '#000000',
      // bodyColor = '#969696';
      bodyColor: '#000000',
      bodyBackground: '#e8f5e9',
      // this.bodyBackground = '#B7DCB9';
      boxShadows: '#000000',
      dropShadows: '#000000',
      link: '#2EAD36',
      hoverFocus: '#81c784',
      buttonColor: '#f1f8e9',
      buttonBackground: '#4CCC6A',
      buttonBorder: '#3eaa98',
      fontFamilySansSerif: '',
      fontFamilyMonospace: '',
      h1Size: '21px',
      h1Color: '#212121',
      h2Size: '18px',
      h2Color: '#212121',
      h3Size: '15px',
      h3Color: '#212121',
    };
    return obj;
  }
}
